import { render, staticRenderFns } from "./NewgameWrapper.vue?vue&type=template&id=34548c64"
import script from "./NewgameWrapper.vue?vue&type=script&lang=js"
export * from "./NewgameWrapper.vue?vue&type=script&lang=js"
import style0 from "./NewgameWrapper.vue?vue&type=style&index=0&id=34548c64&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports